// import dropdown, { DUE, PHASE } from "../../utils/constants";


let dropdown = {};

// Overview
dropdown.DUE = [
  { id: "Due today", name: "Due today" },
  { id: "Due this month", name: "Due this month" }
];
dropdown.PHASE = [
  { id: "New", name: "New" },
  { id: "Draft", name: "Draft" },
  { id: "Live", name: "Live" },
  { id: "Screening", name: "Screening" },
  { id: "Contract", name: "Contract" },
  { id: "Check-in", name: "Check-in" },
  { id: "Rented", name: "Rented" }
];
dropdown.PHASE2 = [
  {id: 1, name: "New"}, 
  {id: 2, name: "Draft"}, 
  {id: 3, name: "Live"}, 
  {id: 4, name: "Screening"}, 
  {id: 5, name: "Contract"}, 
  {id: 6, name: "Check-in"}, 
  {id: 7, name: "Rented"}
];
dropdown.PRIO = [
  { id: "High", name: "High" },
  { id: "Mid", name: "Mid" },
  { id: "Low", name: "Low" }
];
dropdown.TYPE = [
  { id: "Apartment", name: "Apartment" },
  { id: "Storage", name: "Storage" },
  { id: "House", name: "House" },
  { id: "Studio", name: "Studio" }
];
dropdown.STATUS = [
  { id: "Draft", name: "Draft" },
  { id: "Draft_y", name: "Draft_y" },
  { id: "Draft_z", name: "Draft_z" },
  { id: "Todo", name: "Todo" },
  { id: "-- Un-type", name: "-- Un-type" }
];
dropdown.PAYMENT = [
  { id: "Not received", name: "Not received" },
  { id: "Payment received", name: "Payment received" }
];
dropdown.TENANTS = [
  { id: "Currently tenanted", name: "Currently tenanted" },
  { id: "Vacant", name: "Vacant" }
];
dropdown.PAYMENT2 = [
  { "id": 1, "name": "Payment received" },
  { "id": 2, "name": "Not received" }, 
  { "id": 3, "name": "Invoiced" }
];
dropdown.LOCATION_TYPE = [
  { id: "At the edge of the forest", name: "At the edge of the forest" },
  { id: "On a busy road", name: "On a busy road" },
  { id: "Near a park", name: "Near a park" },
  { id: "On a quiet road", name: "On a quiet road" },
  { id: "On a waterway", name: "On a waterway" },
  { id: "By water", name: "By water" },
  { id: "Sheltered location", name: "Sheltered location" },
  { id: "Outside a developed area", name: "Outside a developed area" },
  { id: "In a wooded area", name: "In a wooded area" },
  { id: "In the center", name: "In the center" },
  { id: "In a residential area", name: "In a residential area" },
  { id: "Rural location", name: "Rural location" },
  { id: "Open area location", name: "Open area location" }
];
dropdown.DEPOSIT_AMOUNT = [
  { id: "1.5 x Monthly Rent", name: "1.5 x Monthly Rent" },
  { id: "1 x Monthly Rent", name: "1 x Monthly Rent" },
  { id: "2 x Monthly Rent", name: "2 x Monthly Rent" },
  { id: "3 x Monthly Rent", name: "3 x Monthly Rent" },
  { id: "Not applicable", name: "Not applicable" }
];
dropdown.CONTRACT_DURATION = [
  { id: "Bepaalde tijd", name: "Bepaalde tijd" },
  { id: "Bepaalde tijd met optie tot onbepaalde tijd", name: "Bepaalde tijd met optie tot onbepaalde tijd" },
  { id: "Onbepaalde tijd", name: "Onbepaalde tijd" }
];
dropdown.CONSTRUCTIONS_YEARS = [
  { id: "1906-1930", name: "1906-1930" },
  { id: "1931-1944", name: "1931-1944" },
  { id: "1945-1959", name: "1945-1959" },
  { id: "1960-1970", name: "1960-1970" },
  { id: "1971-1980", name: "1971-1980" },
  { id: "1981-1990", name: "1981-1990" },
  { id: "1991-2000", name: "1991-2000" },
  { id: "2001-2010", name: "2001-2010" },
  { id: "After 2010", name: "After 2010" },
  { id: "Before 1906", name: "Before 1906" }
];
dropdown.CONSTRUCTIONS_TYPE = [
  { id: "Existing Building", name: "Existing Building" },
  { id: "New construction", name: "New construction" }
];
dropdown.TELEVISION_INTERNET = [
  { id: "Included", name: "Included" },
  { id: "Excluded", name: "Excluded" }
];
dropdown.UTILITIES = [
  { id: "Included", name: "Included" },
  { id: "Excluded", name: "Excluded" }
];
// BATHROOM_AMENITIES
dropdown.BATHROOM_AMENITIES = [
  { id: "Shower cubicle", name: "Shower cubicle" },
  { id: "Double sinks", name: "Double sinks" },
  { id: "Walk-in shower", name: "Walk-in shower" },
  { id: "Jacuzzi", name: "Jacuzzi" },
  { id: "Bathtub", name: "Bathtub" },
  { id: "Sauna", name: "Sauna" },
  { id: "Toilet", name: "Toilet" },
  { id: "Washbasin", name: "Washbasin" }
];

// OUTDOOR_SPACE
dropdown.OUTDOOR_SPACE = [
  { id: "Balcony", name: "Balcony" },
  { id: "Roof terrace", name: "Roof terrace" },
  { id: "French balcony", name: "French balcony" },
  { id: "Terrace", name: "Terrace" },
  { id: "Garden", name: "Garden" },
  { id: "Not applicable", name: "Not applicable" }
];

// HOUSE_SHARE
dropdown.HOUSE_SHARE = [
  { id: "Allowed", name: "Allowed" },
  { id: "Not allowed", name: "Not allowed" }
];

// FURNISHINGS
dropdown.FURNISHINGS = [
  { id: "Not furnished", name: "Not furnished" },
  { id: "Fully furnished", name: "Fully furnished" },
  { id: "Partly furnished", name: "Partly furnished" }
];

// ENERGY_LABEL
dropdown.ENERGY_LABEL = [
  { id: "A++++-label", name: "A++++" },
  { id: "A+++-label", name: "A+++" },
  { id: "A++-label", name: "A++" },
  { id: "A+-label", name: "A+" },
  { id: "A-label", name: "A" },
  { id: "B-label", name: "B" },
  { id: "C-label", name: "C" },
  { id: "D-label", name: "D" },
  { id: "E-label", name: "E" },
  { id: "F-label", name: "F" },
  { id: "G-label", name: "G" },
  { id: "Not applicable", name: "Not applicable" }
];
dropdown.PARKING_TYPE = [
  { id: "Own parking spot", name: "Own parking spot" },
  { id: "Indoor garage", name: "Indoor garage" },
  { id: "Public parking", name: "Public parking" }
];
dropdown.SMOKING = [
  { id: "Not allowed", name: "Not allowed" },
  { id: "Allowed", name: "Allowed" }
];
dropdown.PETS = [
  { id: "Not allowed", name: "Not allowed" },
  { id: "Allowed", name: "Allowed" }
];
dropdown.DOCUMENT_TYPE = [
  { id: "RENTAL_CONTRACTS", name: "RENTAL_CONTRACTS" },
  { id: "CHECK_IN_REPORTS", name: "CHECK_IN_REPORTS" },
  { id: "CHECKOUT_REPORTS", name: "CHECKOUT_REPORTS" },
  { id: "OTHER_DOCUMENTS", name: "OTHER_DOCUMENTS" }
];
dropdown.DOCUMENT_TYPE_NAME = [
  { id: "Rental contracts", name: "Rental contracts" },
  { id: "Check-in reports", name: "Check-in reports" },
  { id: "Checkout reports", name: "Checkout reports" },
  { id: "Other documents", name: "Other documents" }
];
dropdown.YES_NO = [
  { id: "Yes", name: "Yes" },
  { id: "No", name: "No" }
];
dropdown.YES_NO_ID = [
  { id: "1", name: "Yes" },
  { id: "2", name: "No" }
];

dropdown.PROPERTY_OVERVIEW_SORT_BY = [
  {
    sortField: null,
    sortOrder: null,
  },
  {
    sortField: "RENT_PRICE",
    sortOrder: "ASC"
  },
  {
    sortField: "RENT_PRICE",
    sortOrder: "DESC"
  }
]

let DUE = dropdown.DUE;
let PHASE = dropdown.PHASE;
let PHASE2 = dropdown.PHASE2;
let PRIO = dropdown.PRIO;
let TYPE = dropdown.TYPE;
let STATUS = dropdown.STATUS;
let PAYMENT = dropdown.PAYMENT;
let PAYMENT2 = dropdown.PAYMENT2;
let PROPERTY_OVERVIEW_SORT_BY = dropdown.PROPERTY_OVERVIEW_SORT_BY;

export { dropdown as default, DUE, PHASE, PHASE2, PRIO, TYPE, STATUS, PAYMENT, PAYMENT2, PROPERTY_OVERVIEW_SORT_BY };